<script setup lang="ts">
const { title, message, actionLabel, showProgress = false, isProcessing = false } = defineProps<{
  title: string
  message: string
  actionLabel?: string
  showProgress?: boolean
  isProcessing?: boolean
}>()

const emit = defineEmits<{
  action: []
}>()
</script>

<template>
  <AuthLayoutCard>
    <template #title>
      {{ title }}
    </template>

    <template #message>
      {{ message }}
    </template>

    <ProgressBar v-if="showProgress" class="w-100%" mode="indeterminate" style="height: 6px" />

    <Button v-if="actionLabel" :label="actionLabel" :loading="isProcessing" class="w-50" rounded @click="emit('action')" />
  </AuthLayoutCard>
</template>
